import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

const AdminLogin = () => {
  const history = useHistory(); // To handle navigation
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  const handleLogin = (e) => {
    e.preventDefault();
    // For demonstration, validate with hardcoded credentials.
    if (username === 'admin' && password === '1234') {
      history.push('/dashboard'); // Redirect to dashboard
    } else {
      alert('Invalid credentials. Please try again.');
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <h1>Welcome Back</h1>
        <p className="subtitle">Log in to your account</p>
        <form onSubmit={handleLogin}>
          <div className="form-group">
            <label htmlFor="username">Username</label>
            <input
              type="text"
              id="username"
              placeholder="Enter your username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
          </div>
          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          <div className="options">
            <a href="/forgot-password" className="forgot-password">Forgot Password?</a>
            <a href="/signup" className="signup">Sign Up</a>
          </div>
          <button type="submit" className="btn-primary">Log In</button>
        </form>
      </div>
    </div>
  );
};



export default AdminLogin;
